export const GET_PRODUCTS: string = 'src/pages/products/GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS: string =
  'src/pages/products/GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILED: string =
  'src/pages/products/GET_PRODUCTS_FAILED';
export const GET_PRODUCT: string = 'src/pages/products/GET_PRODUCT';
export const GET_PRODUCT_SUCCESS: string =
  'src/pages/products/GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAILED: string =
  'src/pages/products/GET_PRODUCT_FAILED';

export const GET_CATEGORIES: string = 'src/pages/products/GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS: string =
  'src/pages/products/GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILED: string =
  'src/pages/products/GET_CATEGORIES_FAILED';

export const GET_VARIANT: string = 'src/pages/products/GET_VARIANT';
export const GET_VARIANT_SUCCESS: string =
  'src/pages/products/GET_VARIANT_SUCCESS';
export const GET_VARIANT_FAILED: string =
  'src/pages/products/GET_VARIANT_FAILED';

export const DELETE_VARIANT: string = 'src/pages/products/DELETE_VARIANT';
export const DELETE_VARIANT_SUCCESS: string =
  'src/pages/products/DELETE_VARIANT_SUCCESS';
export const DELETE_VARIANT_FAILED: string =
  'src/pages/products/DELETE_VARIANT_FAILED';

export const UPDATE_PRODUCTS: string = 'src/pages/products/UPDATE_PRODUCT';
export const UPDATE_PRODUCTS_SUCCESS: string =
  'src/pages/products/UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCTS_FAILED: string =
  'src/pages/products/UPDATE_PRODUCT_FAILED';

export const CREATE_PRODUCTS: string = 'src/pages/products/CREATE_PRODUCTS';
export const CREATE_PRODUCTS_SUCCESS: string =
  'src/pages/products/CREATE_PRODUCTS_SUCCESS';
export const CREATE_PRODUCTS_FAILED: string =
  'src/pages/products/CREATE_PRODUCTS_FAILED';

export const GET_PRODUCT_VARIANTS: string =
  'src/pages/products/GET_PRODUCT_VARIANTS';
export const GET_PRODUCT_VARIANTS_SUCCESS: string =
  'src/pages/products/GET_PRODUCT_VARIANTS_SUCCESS';
export const GET_PRODUCT_VARIANTS_FAILED: string =
  'src/pages/products/GET_PRODUCT_VARIANTS_FAILED';

export const GET_PRODUCT_VARIANT_INVENTORY_ITEMS: string =
  'src/pages/products/GET_PRODUCT_VARIANT_INVENTORY_ITEMS';
export const GET_PRODUCT_VARIANT_INVENTORY_ITEMS_SUCCESS: string =
  'src/pages/products/GET_PRODUCT_VARIANT_INVENTORY_ITEMS_SUCCESS';
export const GET_PRODUCT_VARIANT_INVENTORY_ITEMS_FAILED: string =
  'src/pages/products/GET_PRODUCT_VARIANT_INVENTORY_ITEMS_FAILED';

export const GET_PRODUCTS_INVONTORY: string =
  'src/pages/products/GET_PRODUCTS_INVONTORY';
export const GET_PRODUCTS_INVONTORY_SUCCESS: string =
  'src/pages/products/GET_PRODUCTS_INVONTORY_SUCCESS';
export const GET_PRODUCTS_INVONTORY_FAILED: string =
  'src/pages/products/GET_PRODUCTS_INVONTORY_FAILED';

export const GET_ALL_PRODUCTS: string = 'src/pages/products/GET_ALL_PRODUCTS';
export const GET_ALL_PRODUCTS_SUCCESS: string =
  'src/pages/products/GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAILED: string =
  'src/pages/products/GET_ALL_PRODUCTS_FAILED';

export const GET_PARTNER_CATEGORIES: string =
  'src/pages/products/GET_PARTNER_CATEGORIES';
export const GET_PARTNER_CATEGORIES_SUCCESS: string =
  'src/pages/products/GET_PARTNER_CATEGORIES_SUCCESS';
export const GET_PARTNER_CATEGORIES_FAILED: string =
  'src/pages/products/GET_PARTNER_CATEGORIES_FAILED';

export const GET_VITRIN_PRODUCTS: string =
  'src/pages/products/GET_VITRIN_PRODUCTS';
export const GET_VITRIN_PRODUCTS_SUCCESS: string =
  'src/pages/products/GET_VITRIN_PRODUCTS_SUCCESS';
export const GET_VITRIN_PRODUCTS_FAILED: string =
  'src/pages/products/GET_VITRIN_PRODUCTS_FAILED';

export const CLEAR_PRODUCT: string = 'src/pages/products/CLEAR_PRODUCT';
